module.exports = __webpack_public_path__ + "img/income-and-expense-log_B09JY9XQK6.44913ce1.jpg";